<div *ngIf="audio?.link">
  <!-- <div class="text-xl text-gray-600 font-bold mb-3">
    Audio Tour
  </div> -->
  <div>
    <div *ngIf="audio.link" class="w-full mobile:w-full">
      <audio [src]="audio.link" controls class="w-full max-w-[500px]"></audio>
    </div>
    <div *ngIf="audio.description" class="w-full mt-4 ml-2 mobile:w-full mobile:text-sm {{textColor}}">
      <p>{{ audio.description }}</p>
    </div>
  </div>
</div>